import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DataGridPremium } from '@mui/x-data-grid-premium';

import { PatientTravelApi } from '../../../../../../../api';
import { muiDataGridLocaleText } from '../../../../../../../services/i18n/mui';
import { NSPP_TRAVEL } from '../../../../../../../services/i18n/namespaces';
import { useCurrentRoute } from '../../../../../../root/router';
import PaymentsSectionHeader from '../PaymentsSection/PaymentsSectionHeader/PaymentsSectionHeader';

import { AddUnexpectedTravelButton } from './AddUnexpectedTravelButton';
import useTravelGridData from './useTravelGridData';

import './TravelSection.scss';

export default function TravelSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const currentRoute = useCurrentRoute();
  const ssuPatientId = currentRoute.params?.ssuPatientId;
  const [loading, setLoading] = useState(true);
  const [columns, data, setData] = useTravelGridData();

  const loadData = useCallback(
    function() {
      if (!ssuPatientId) return;
      setLoading(true);
      PatientTravelApi.getPatientTravelRequests(ssuPatientId).then(res => {
        setData(res.data);
        setLoading(false);
      });
    },
    [ssuPatientId, setData]
  );

  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <div className={'travel-section'}>
      <PaymentsSectionHeader title={t(`${NSPP_TRAVEL}:travelRequests.travelRequests`)}>
        <AddUnexpectedTravelButton />
      </PaymentsSectionHeader>
      <DataGridPremium
        loading={loading}
        getRowId={getRowId}
        rowHeight={38}
        rows={data}
        columns={columns}
        disableRowSelectionOnClick
        localeText={muiDataGridLocaleText({ noRowsLabel: 'No results to display' })}
        onRowClick={function({ row }) {
          if (!row.id) {
            return;
          }
          navigate(
            `./travel-request/${row.id}?ssuPatientEncounterId=${row.sitePatientEncounterId ||
              ''}&protocolEncounterKey=${row.protocolEncounterKey || ''}`
          );
        }}
        disableRowGrouping
        disableAggregation
        disablePivoting
      />
    </div>
  );

  function getRowId(row) {
    return row.sitePatientEncounterId || row.protocolEncounterKey;
  }
}
